import * as PrefabManager from '../PrefabManager';
import { getLimbHandles, setPositionLimb, startAddingJoint, startPositioningLimb } from '../vehicles/NoVehicle';
import {Humanoid} from '../humanoids/Humanoid'
import {
    game
} from "../../Game";
import { applyColorMatrixMultiple } from '../../b2Editor/utils/colorMatrixParser';

export class NPC extends PrefabManager.basePrefab {
    constructor(target) {
		super(target);
		this.isNPC = true;
		this.flipped = false;
		this.character = game.editor.activePrefabs[this.lookupObject.character.body.mySprite.data.subPrefabInstanceName].class;
		this.character.calculateJointOffsets();
		if(this.prefabObject.settings){
			this.flip(this.prefabObject.settings.isFlipped);
			if(this.prefabObject.settings?.limbs){
				for(let key in this.prefabObject.settings.limbs){
					this.positionLimb(key);
				}
			}
		}
        game.editor.applyToObjects("move", {x:0, y:0}, this.lookupObject._bodies);
		this.initialized = true;
        if(this.prefabObject.settings) this.applyColorMatrix(this.prefabObject.settings.colorMatrix);
	}

	applyColorMatrix(cm){
        if(!cm) return;
        const textures = [];
        this.lookupObject._bodies.map(body => body.myTexture && textures.push(body.myTexture));
        applyColorMatrixMultiple(textures, cm)
    }

	init(){
		super.init();
        this.character.life = this.prefabObject.settings.life;
		if(this.prefabObject.settings.interactivity === 'invincible'){
			this.character.invincible = true;
		}else if(this.prefabObject.settings.interactivity === 'non-interactive'){
			this.character.invincible = true;
			this.character.dollMode = true;
			this.character.lookupObject._bodies.forEach(body => {
				game.editor.setBodyCollision(body, [2]);
			})
		}
	}
	positionLimb(limb){
        let x = this.prefabObject.settings.limbs[limb][0];
        let y = this.prefabObject.settings.limbs[limb][1];
        const l = Math.sqrt(x*x+y*y);
        const a = Math.atan2(y,x);

        // must restore rotation with prefab rotation

        x = l * Math.cos(a + this.prefabObject.rotation*game.editor.DEG2RAD);
        y = l * Math.sin(a + this.prefabObject.rotation*game.editor.DEG2RAD);

        x += this.prefabObject.x / game.editor.PTM;
        y += this.prefabObject.y / game.editor.PTM;

        this.character.positionLimb(limb, x, y);
    }
	getEditorHandles(){
		return getLimbHandles(this.character);
	}
	dragEditorHandle(limb){
		setPositionLimb(this.prefabObject, limb);
	}
	set(property, value) {
		super.set(property, value);
        switch (property) {
            case 'isFlipped':
                this.flip(value);
				break;
			case 'skin':
				this.character.setSkin(value-1);
				break;
			case "selectJointTarget":
				this.prefabObject.class.jointTarget = value;
        }
	}

	flipLimbs(){
		for(let key in this.prefabObject.settings.limbs){

			let x = this.prefabObject.settings.limbs[key][0];
			let y = this.prefabObject.settings.limbs[key][1];

			let a = Math.atan2(y, x);
			let l = Math.sqrt(x*x + y*y);

			// rotate back on prefab
			x = l * Math.cos(a+this.prefabObject.rotation*game.editor.DEG2RAD);
			y = l * Math.sin(a+this.prefabObject.rotation*game.editor.DEG2RAD);
			x += this.prefabObject.x / game.editor.PTM;
			y += this.prefabObject.y / game.editor.PTM;

			// rotate around body
			const body = this.prefabObject.class.lookupObject['body'];
			const dx = x-body.GetPosition().get_x();
			const dy = y-body.GetPosition().get_y();
			const dl = Math.sqrt(dx*dx + dy*dy);
			let da = Math.atan2(dy, dx);

			x = dl * Math.cos(da-body.GetAngle());
			y = dl * Math.sin(da-body.GetAngle());
			x *= -1;

			da = Math.atan2(y, x);

			x = body.GetPosition().get_x() + dl * Math.cos(da+body.GetAngle());
			y = body.GetPosition().get_y() + dl * Math.sin(da+body.GetAngle());

			x -= this.prefabObject.x / game.editor.PTM;
			y -= this.prefabObject.y / game.editor.PTM;


			// rotate back around prefab
			a = Math.atan2(y,x);
			l = Math.sqrt(x*x + y*y);
			x = l * Math.cos(a-this.prefabObject.rotation*game.editor.DEG2RAD);
			y = l * Math.sin(a-this.prefabObject.rotation*game.editor.DEG2RAD);

			this.prefabObject.settings.limbs[key][0] = x;
			this.prefabObject.settings.limbs[key][1] = y;

		}
	}
	flip(flipped){
		if(this.flipped != flipped){
			if(this.initialized && this.prefabObject.settings?.limbs){
				this.flipLimbs();
			}
			this.character.flip();
			if(this.initialized && this.prefabObject.settings?.limbs){
				for(let key in this.prefabObject.settings.limbs){
					this.positionLimb(key);
				}
			}
			this.flipped = flipped;
		}
	}
}

const setColorMatrix = prefab =>{
    const callback = cm=>{
        prefab.settings.colorMatrix = cm;
    }

    const textures = [];
    prefab.class.lookupObject._bodies.map(body => body.myTexture && textures.push(body.myTexture));
    game.editor.ui.showColorMatrixEditor(prefab.settings.colorMatrix, textures, callback, prefab.settings)
}

NPC.settings = Object.assign({}, NPC.settings, {
    "isFlipped": false,
    "isAwake": true,
	"skin": 1,
	"life": 300,
	"positionLeftArm": prefab=>startPositioningLimb(prefab, Humanoid.BODY_PARTS.ARM_LEFT),
    "positionRightArm": prefab=>startPositioningLimb(prefab, Humanoid.BODY_PARTS.ARM_RIGHT),
    "positionLeftLeg": prefab=>startPositioningLimb(prefab, Humanoid.BODY_PARTS.LEG_LEFT),
    "positionRightLeg": prefab=>startPositioningLimb(prefab, Humanoid.BODY_PARTS.LEG_RIGHT),
    "positionHead": prefab=>startPositioningLimb(prefab, Humanoid.BODY_PARTS.HEAD),
    "selectJointTarget": "body",
    "addJoint": prefab=>startAddingJoint(prefab),
    "setColorMatrix": prefab=>setColorMatrix(prefab),
    "interactivity": 'interactive',
});
NPC.settingsOptions = Object.assign({}, NPC.settingsOptions, {
    "isFlipped": false,
	"isAwake": true,
    "skin": {
        min: 1,
        max: 16,
        step: 1
    },
    "life": {
        min: 1.0,
        max: 10000.0,
        step: 1.0
	},
	"positionLeftArm": '$function',
    "positionRightArm": '$function',
    "positionLeftLeg": '$function',
    "positionRightLeg": '$function',
    "positionHead": '$function',
    "selectJointTarget": [...Object.values(Humanoid.BODY_PARTS)],
    "addJoint": '$function',
	"setColorMatrix": '$function',
	'interactivity':['interactive', 'invincible', 'non-interactive'],
});
